var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopilotsBoxIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_303_173",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_303_173",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACaUlEQVR4nO3dvU4bURDF8X8V8gYBkudIlSJVkCV4ExJKOw8IEVXgUZBB7FYTWdoihT92vXs9M3fPkaahuJZ/PozxroRBURRFURQlUz4Cd8Aj8AqY47TAPfCVyvIFeHbGtS3zDvygoiZHRLbasO8CYNocsB8DQNocsNcBEO2/easV24LNtwMvfgNckzAWbKgVOyJ0ldhRoavDjgxdFXZ06GqwM0BXgZ0FOj12JujU2Nmg02JnhE6JnRU6HXZm6FTY2aHTYNcAvcn3HpdYXe9BWrC5LIi9ueHrFgs2y5HPZx/25u66W7xhbQvGsmCz3WIzG7d4P3ETtD+KqdG4g2l1EHu0oxG0ewvVaPzhtDrwR9WORtDujTM1GnckrQ78AbWjiTX6wIKgB7em6a4pn3ez7H5W8vx2bo1ugMWWx1lMhL3r/NWcoFvgZs9jXXU3SUuc/2ku0O0B5LHYh86/nAN0s+PXeVeGrpE+5/+uHboZiDwUu8/5Q144t5xiXRy7RvqcP3QVuaVkkxcj2jh1k1NCtwOadkwrSzQ5HXRbGK4kchro5gSroMS6SAXdTtC00m+e6aGbCZtW+s/B1NBLhw8gY85PC33u8JF67PlVQV8VvEg0xfnpoFcOlz2nXBdpoNsO+6KbVYEL+SXPTwNtFY2gEbR7C9Vo/OG0OvBH1Y5G0O6NMzUadyStDvwBtaOJNfrAgqDdW6hG4w+n1YE/qnY0M4SO9q/nreC8eEJn+TIFm2D+eEL/CgBgJ5pbT+gz4CkAghWev8AHAnyF01PlyJ8Jkk2zf3Z7rIY3yDXw0K0L9yYriqIoiqLQO/8A8l1RtEDb4ZEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotsBoxIcon3);
export default __webpack_public_path__ + "static/media/CopilotsBoxIcon3.de57020ac03da59556de3b8ac7ff85ec.svg";
export { ForwardRef as ReactComponent };